import { registerVueComponentAndAngularBindings } from '/vodalys/vvuejs'

import PlanVWallet from './PlanVWallet.vue' 
registerVueComponentAndAngularBindings('plan:vwallet', 'planVWallet', PlanVWallet);